import type {
  GridCell,
  Rectangle,
  SizedGridColumn,
  Theme,
} from "@glideapps/glide-data-grid";
import type { IAiSpreadsheetCell } from "@/payroll/ai-script/types";

export interface AdaptedSpreadsheetSheet {
  columns: SizedGridColumn[];
  rowCount: number;
  isAddRowCell: (col: number, row: number) => boolean;
  getCellContent: (col: number, row: number) => GridCell;
  // Without this, Glide's single-cell copy is a no-op.
  getCellsForSelection: (rect: Rectangle) => GridCell[][];
  getCellRecord: (col: number, row: number) => IAiSpreadsheetCell | undefined;
  getManualRowCell: (row: number) => IAiSpreadsheetCell | undefined;
  getSearchMatches: (query: string) => SpreadsheetSearchMatch[];
  getTextOverflow: (col: number, row: number) => TextOverflowSpan | undefined;
  getRowHeight: (row: number) => number;
}

export interface SpreadsheetAdapterOptions {
  onHyperlinkClick?: (url: string) => void;
}

export interface SpreadsheetSearchMatch {
  cellId: string;
  col: number;
  row: number;
}

export interface TextOverflowSpan {
  sourceCol: number;
  displayData: string;
  themeOverride: Partial<Theme> | undefined;
}

export const coordinateKey = (col: number, row: number) => `${row}:${col}`;
